import isNil from 'lodash-es/isNil';
import { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';

export const setValuesHanlder =
  <TFieldValues extends FieldValues>(form: UseFormReturn<TFieldValues>) =>
  (values: Partial<TFieldValues>) => {
    if (isNil(values)) {
      return;
    }

    for (const [key, value] of Object.entries(values)) {
      form.setValue(key as FieldPath<TFieldValues>, value);
    }
  };
